import { makeObservable, observable, action, flow } from "mobx";

class FilesStore {
  files = [];
  isLoading = false;
  error = null;

  constructor() {
    makeObservable(this, {
      // Observables
      files: observable,
      isLoading: observable,
      error: observable,

      // Actions
      setFiles: action,
      setLoading: action,
      setError: action,

      // Flows (async actions)
      fetchFiles: flow,
      getFileById: flow,
      uploadFile: flow,
      deleteFile: flow
    });
  }

  // Actions
  setFiles = (files) => {
    this.files = files;
  };

  setLoading = (status) => {
    this.isLoading = status;
  };

  setError = (error) => {
    this.error = error;
  };

  // API Actions
  *fetchFiles(folderId) {
    // TODO: Implement call to service
  }

  *getFileById(id) {
    // TODO: Implement call to service
  }

  *uploadFile(folderId, fileData) {
    // TODO: Implement call to service
  }

  *deleteFile(id) {
    // TODO: Implement call to service
    
  }
}

export default FilesStore;